import { Getters } from 'vuex-smart-module';
import ProductState from './state';

export default class ProductGetters extends Getters<ProductState> {
  get related_products() {
    return this.state.related_prods;
  }
}
